// Version : 0.0.1
// Author : Vignesh

const TrailBalanceTypes = {
	/** ***************** GET TRAIL_BALANCE START *********************** */
	GET_TRAIL_BALANCE_START: 'trail_balance_start',
	GET_TRAIL_BALANCE_SUCCESS: 'trail_balance_success',
	GET_TRAIL_BALANCE_FAILURE: 'trail_balance_failure',
	GET_TRAIL_BALANCE_RESPONSE_RESET: 'trail_balance_response_reset',
	GET_TRAIL_BALANCE_RESPONSE_CHANGED: 'trail_balance_response_changed',
};
export default TrailBalanceTypes;
